export default __webpack_public_path__ + "static/media/img1.338fa7c0.jpeg";